// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"2f2d4627","66":"89a52057","148":"ec1a947a","239":"e39fb35b","315":"f4068a24","336":"5ad1a36a","527":"0b448d49","530":"b3dc0cff","634":"d95b2d19","664":"357f8787","690":"ade96c46","703":"161228fd","724":"ee4ffbc3","776":"781c76f2","934":"b0f56749"}[chunkId] + ".chunk.js";
};